import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

import ServiceAddOnForm from '@/features/services/serivce-addon-form'

export const Route = createFileRoute(
  '/_authenticated/dashboard/services/new',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-4">
          <Link to="/dashboard/services">
            <Button size="icon" variant="outline" className="rounded-full">
              <ArrowLeft />
            </Button>
          </Link>
        </div>
        <CardTitle>
          Create A Service Add On
        </CardTitle>
        <CardDescription>
          Use this form to enter a new Service Add ons into the system
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ServiceAddOnForm />
      </CardContent>
    </Card>
  )
}
